import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Routes, RouterModule } from '@angular/router';
import { AcceuilComponent } from './components/acceuil/acceuil.component';
import { AdressesComponent } from './components/adresses/adresses.component';
import { AgendaComponent } from './components/agenda/agenda.component';
import { InfoComponent } from './components/info/info.component';


const routes: Routes = [
  { path: '', component: AcceuilComponent,data: { animation: 'one'} },
  { path: 'adresses', component: AdressesComponent,data: { animation: 'two'} },
  { path: 'agenda', component: AgendaComponent,data: { animation: 'three'} },
  { path: 'infos', component: InfoComponent,data: { animation: 'four'} }

  
];

@NgModule({
  imports: [RouterModule.forRoot(routes),
    BrowserModule,
    BrowserAnimationsModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
